'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var magicCommon = require('@gig/magic-common');
var magicFormBuilder = require('@gig/magic-form-builder');
var getCountries = require('@gig/magic-sdk/dist/adapter/users/getCountries');

var isNonSHPostalCodeValidator = function (postCode, formData) {
    return magicFormBuilder.isNonSHPostalCode(postCode, formData.country.value);
};
var isValidCanadianPostalCodeValidator = function (postCode, formData) {
    return magicFormBuilder.isValidCanadianPostalCode(postCode, formData.country.value);
};
function postCode() {
    return {
        id: 'postcode',
        component: 'magic-ui-form-field',
        isDataField: true,
        type: 'text',
        testId: 'step2-postcode',
        properties: {
            placeholder: magicCommon.translate('sign-up-step-two.postcode.placeholder'),
        },
        validationDisplay: magicFormBuilder.ValidationDisplay.OnTouchShowMessage,
        validation: [
            {
                name: 'required',
                fn: magicFormBuilder.required,
                message: magicCommon.translate('sign-up-step-two.postcode.required-error'),
            },
            {
                name: 'max-length',
                fn: magicFormBuilder.maxLength(20),
                message: magicCommon.translate('sign-up-step-two.postcode.max-length-error'),
            },
            {
                name: 'containsNumber',
                fn: magicFormBuilder.containsNumber,
                message: magicCommon.translate('sign-up-step-two.postcode.contains-number-error'),
            },
            {
                name: 'isNonSHPostalCode',
                fn: isNonSHPostalCodeValidator,
                message: magicCommon.translate('sign-up-step-two.postcode.error'),
                triggeringFields: ['country'],
            },
            {
                name: 'isValidCanadianPostalCode',
                fn: isValidCanadianPostalCodeValidator,
                message: magicCommon.translate('sign-up-step-two.postcode.canadian-postal-code-error'),
                triggeringFields: ['country'],
            },
        ],
        converter: function (_a) {
            var postcode = _a.postcode, country = _a.country;
            var postalCode = postcode.value;
            if (country) {
                var formattedPostalCode = country.value === getCountries.Country.CANADA &&
                    !postalCode.includes(' ')
                    ? postalCode.slice(0, 3) + " " + postalCode.slice(3)
                    : postalCode;
                return { postalCode: formattedPostalCode };
            }
            return { postalCode: postalCode };
        },
    };
}

exports.postCode = postCode;
